import { Fragment, useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { Button, Col, Dropdown, Form, Row } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import { SafeDatatable } from "../../../components/SafeDatatable";
//import ReactDatatable from "@ashvin27/react-datatable";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCogs, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";

import _ from 'lodash';

import moment from 'moment';

import { DatasetDefault, DatasetModel } from "../../../models/dataset.model";
import { RequestInputOutputParamsModel, RequestInputOutputParamsModelDefault } from "../../../models/requestInputOutputParams.model";

import { ErrorHandler } from "../../../services/errorHandler.service";
import { ToastService } from "../../../services/toast.service";
import { HolidayService } from "../../../services/holiday.service";
import { FileExportService } from "../../../services/fileExport.service";
import storageService from "../../../services/storage.service";
import { HeaderList } from "../../../components/HeaderList";
import { CustomModal } from "../../../components/Modal";
import DropdownButtonExport from "../../../components/dropdownButton/export";
import { ButtonClean, ButtonSearch } from "../../../components/buttons";
import UtilService from "../../../services/util.service";

import LocaleService from "../../../services/locale.service";

import { AddressStateModel } from "../../../models/addressState.model";
import DatePicker from "react-datepicker";
import CustomRangeDatePicker from "../../../components/CustomDatePickerRange";

const HolidayList = () => {
  const { pathname } = useLocation();
  const [isLoading, setLoading] = useState(false);
  const { t } = useTranslation();
  const idiom = storageService.getIdiom();
  const [data, setData] = useState<DatasetModel>();
  const [showRemoveModal, setShowRemoveModal] = useState({
    id: 0,
    show: false,
    name: "",
    entity: undefined
  });
  const history = useHistory();
  // Adicionando o filtro de data:
  const today = moment();
  const firstDayOfMonth = today.clone().startOf('month').format('YYYY-MM-DD');
  const lastDayOfMonth = today.clone().endOf('month').format('YYYY-MM-DD');

  const [startDate, setStartDate] = useState(moment(firstDayOfMonth).toDate());
  const [endDate, setEndDate] = useState(moment(lastDayOfMonth).toDate());


  const [dataset, setDataset] = useState<DatasetModel>({
    ...JSON.parse(JSON.stringify(DatasetDefault)), dataset: 'holiday', filters: {
      holidaytype: [],
      addressStateId: [],
      nameHoliday: "",
      dataHoliday: [firstDayOfMonth, lastDayOfMonth],
    },
    sort: {
      field: 'holiday_date',
      orientation: 'asc'
    }
  });

  const [states, setStates] = useState<AddressStateModel[]>();

  const user = storageService.getUser();

  const [enablesState, setEnablesState] = useState(null);

  const formatDateTime = (value) => {
    return UtilService.formatDate(value, user.locale.formatDate);
  };

  const ListHolidayType = [
    { value: 1, label: t("HOLIDAY.NATIONAL") },
    {
      value: 2, label: t("HOLIDAY.STATE_TYPE")
    }
  ]

  const columns = [
    {
      key: "holidayName",
      text: t(`HOLIDAY.DESCRIPTION`),
      align: "left",
      sortable: true,
    },
    {
      key: "holidayDate",
      text: t(`HOLIDAY.DATE`),
      align: "left",
      sortable: true,
      cell: (record) => {
        return (formatDateTime(record.holidayDate))
        //return record.addressStateId ?  t(`HOLIDAY.STATE_TYPE`): t(`HOLIDAY.NATIONAL`);
      }
    },
    {
      key: "addressStateId",
      text: t(`HOLIDAY.TYPE`),
      align: "left",
      sortable: false,
      cell: (record) => {
        return record.addressStateId ? t(`HOLIDAY.STATE_TYPE`) : t(`HOLIDAY.NATIONAL`);
      }
    },
    {
      key: "holiday_country_name",
      text: t(`HOLIDAY.LOCALE`),
      align: "left",
      sortable: false,
    },
    {
      key: "holiday_state_name",
      text: t(`HOLIDAY.STATE`),
      align: "left",
      sortable: false,
    },
    {
      key: "isFixedVariable",
      text: t(`HOLIDAY.MOVABLE`),
      align: "left",
      sortable: false,
      cell: (record) => {
        return record.isFixedVariable ? t(`NO`) : t(`YES`);
      }
    },
    {
      key: "action",
      text: t(`ACTIONS`),
      className: "action",
      width: 100,
      align: "left",
      sortable: false,
      cell: (record) => {
        return (
          <Fragment>
            <Dropdown className='btn-toolbar'>
              <Dropdown.Toggle
                as={Button}
                variant='primary'
                size='sm'
                className='me-2'>
                <FontAwesomeIcon icon={faCogs} className='me-2' />
              </Dropdown.Toggle>
              <Dropdown.Menu className='dashboard-dropdown dropdown-menu-left mt-2'>
                <Dropdown.Item
                  className='fw-bold'
                  onClick={() => history.push(`${pathname}/edit/${record.id}`)}>
                  <FontAwesomeIcon icon={faEdit} className='me-2' />
                  {(user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin") ? (
                    t("VIEW")
                  ) :
                    t("EDIT")
                  }
                </Dropdown.Item>
                <Dropdown.Item
                  className='fw-bold'
                  onClick={() => actionRemove(record.id, record.holidayName, record)}
                  disabled={user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin"}
                >
                  <FontAwesomeIcon icon={faTrash} className='me-2' /> {t('DELETE')}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Fragment>
        );
      },
    },
  ];

  const getList = async (dataTable, datasetOverride = null) => {
    setLoading(true);

    let requestParams: RequestInputOutputParamsModel = { ...RequestInputOutputParamsModelDefault, datasets: [datasetOverride ||dataset] };

    if (dataTable !== null && requestParams?.datasets) {
      let dataSet = requestParams.datasets[0];
      let pagination = dataSet.pagination;
      pagination.page_number = dataTable.page_number;
      pagination.records_pages = dataTable.page_size;
      if (dataTable.sort_order.column !== null && dataTable.sort_order.column !== "") {
        dataSet.sort.field = dataTable.sort_order.column;
      };
      if (dataTable.sort_order.order !== null && dataTable.sort_order.order !== "") {
        dataSet.sort.orientation = dataTable.sort_order.order;
      };
    } else {
      let pagination = requestParams.datasets[0].pagination;
      pagination.page_number = DatasetDefault.pagination.page_number;
      pagination.records_pages = DatasetDefault.pagination.records_pages;
    }

    let sort = requestParams.datasets[0].sort;
    if (!sort) {
        sort = requestParams.datasets[0].sort = {};
    }
    if (!sort.field || sort.field === null || sort.field.trim?.() === "") {
        sort.field = "holiday_date";
    }
    if (!sort.orientation || sort.orientation === null || sort.orientation.trim?.() === "") {
        sort.orientation = "asc";
    }

    const response: any = await HolidayService.getList(requestParams);
    if (response.success === true && response.result) {
      let d: DatasetModel = _.last(_.filter(response.result.datasets, { dataset: 'holiday' }));
      setData(d);
    } else {
      requestParams.datasets[0].data = null;
      setData(requestParams.datasets[0]);
    }
    setLoading(false);
  };

  const handleSearch = async (event) => {
    if (event != null)
      event.preventDefault();

    const trimnameHoliday = dataset.filters.nameHoliday?.trim() || "";

    const cleanedDataset = {
      ...dataset,
      filters: {
        ...dataset.filters,
        nameHoliday: trimnameHoliday
      },
    };

    await getList(null,cleanedDataset);
  };

  const tableChangeHandler = async (data) => {
    await getList(data);
  };

  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  }

  const query = useQuery();

  const [flagClear, setFlagClear] = useState(false);

  useEffect(() => {
    if (flagClear) {
      handleSearch(null);
      setFlagClear(false);
    }
  }, [flagClear]);

  const handleClean = (e) => {
    const defaultStart = moment().startOf('month').format('YYYY-MM-DD');
    const defaultEnd = moment().endOf('month').format('YYYY-MM-DD');

    setStartDate(moment(defaultStart).toDate());
    setEndDate(moment(defaultEnd).toDate());

    setDataset({
      ...dataset,
      filters: {
        holidaytype: [],
        addressStateId: [],
        nameHoliday: "",
        dataHoliday: [defaultStart, defaultEnd],
      },
        sort: {
        field: "",
        orientation: "",
      },      
    });

    setFlagClear(true);
  };


  const actionRemove = (id, name, entity) => {
    setShowRemoveModal({ id: id, show: true, name: name, entity });
  };

  const handleCloseModal = () =>
    setShowRemoveModal({ id: 0, show: false, name: "", entity: null });

  const remove = async () => {
    if (showRemoveModal.id) {
      try {
        const response: any = await HolidayService.del(showRemoveModal.entity);
        if (ErrorHandler.success(response)) {
          if (response.success) {
            ToastService.success(t('HOLIDAY.REMOVED'));
            await getList(null);
            handleClean(null);
            handleCloseModal();
          }
        }
      } catch (error) { }
    }
  };


  const initialize = async () => {
    await getList(null);
    await LocaleService.getAllStatesbyLocale().then(async (response: any) => {
      if (response.success) {
        let statesList = response.result.datasets.filter((dataset) => { return dataset.dataset === 'states' });
        setStates(statesList[0].data);
      } else {
        setStates([]);
      }
    });
  };

  useEffect(() => {
    initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (dataset?.filters?.holidaytype?.length === 0) {
      setEnablesState(false);
    }
  }, [dataset?.filters?.holidaytype]);

  return (
    <>
      <HeaderList path={`${pathname}/add`} title={t(`HOLIDAY.TITLE`)} disabled={user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin"} />

      <CustomModal
        Title={t('DELETE')}
        Message={`${t('HOLIDAY.REMOVE_ANSWER')} ${showRemoveModal ? showRemoveModal.name : ""}?`}
        close={handleCloseModal}
        cancel={t('CANCEL')}
        show={showRemoveModal ? showRemoveModal.show : false}>
        <Button variant='primary' onClick={remove}>
          {t('YES')}
        </Button>
      </CustomModal>

      <Form>
        <Form.Label>{t('FILTERS')}</Form.Label>
        <Row>
          <Col sm={12} md={6} lg={2} className='mb-4'>
            <Form.Group>
              <Form.Floating>
                <Form.Select
                  id='holidaytype'
                  name='holidaytype'
                  placeholder={t(`HOLIDAY.HOLIDAY_TYPE`)}
                  className='form-control'
                  onChange={(e) => {

                    const value = e.target.value === "" ? null : e.target.value;
                    setDataset({ ...dataset, filters: { ...dataset.filters, holidaytype: [value] } });

                    setEnablesState(value == "1");
                  }}
                  value={
                    dataset?.filters?.holidaytype?.length > 0
                      ? dataset.filters.holidaytype[0]
                      : ""
                  }
                  disabled={isLoading}
                  aria-label={t("HOLIDAY.HOLIDAY_TYPE")}>
                  <option value="">{t("HOLIDAY.HOLIDAY_TYPE")}</option>
                  {_.map(ListHolidayType, (l) => {
                    return (
                      <option key={l.value} value={l.value}>
                        {l.label}
                      </option>
                    );
                  })}
                </Form.Select>
                <label htmlFor="addressStateId">{t("HOLIDAY.HOLIDAY_TYPE")}</label>
              </Form.Floating>
            </Form.Group>
          </Col>
          <Col sm={12} md={6} lg={2} className='mb-4'>
            <Form.Group>
              <Form.Floating>
                <Form.Select
                  id='addressStateId'
                  name='addressStateId'
                  disabled={isLoading || enablesState}
                  onChange={(e) => {
                    const value = e.target.value === "" ? null : e.target.value;
                    setDataset({ ...dataset, filters: { ...dataset.filters, addressStateId: [value] } });
                  }}
                  value={
                    enablesState
                      ? (() => {
                        return "";
                      })()
                      : dataset?.filters?.addressStateId?.length > 0
                        ? (() => {
                          return dataset.filters.addressStateId[0];
                        })()
                        : (() => {
                          return "";
                        })()
                  }
                  aria-label={t("BRANCH.STATE")}>
                  <option value="">{t("BRANCH.STATE")}</option>
                  {_.map(states, (l: AddressStateModel) => {
                    return <option key={l.id_address_state} value={l.id_address_state}>{l.name}</option>
                  })}
                </Form.Select>
                <label htmlFor="addressStateId">{t("BRANCH.STATE")}</label>
              </Form.Floating>
            </Form.Group>
          </Col>

          <Col sm={12} md={6} lg={3} className='mb-4'>
            <Form.Group>
              <Form.Floating>
                <Form.Control
                  id='nameHoliday'
                  type='text'
                  placeholder={t("HOLIDAY.DESCRIPTION")}
                  value={dataset.filters.nameHoliday}
                  onChange={(e) => {
                    setDataset({ ...dataset, filters: { ...dataset.filters, nameHoliday: e.target.value } });
                  }}
                  disabled={isLoading}
                />
                <label htmlFor='nameHoliday'>{t("HOLIDAY.DESCRIPTION")}</label>
              </Form.Floating>
            </Form.Group>
          </Col>

          <Col sm={12} md={6} lg={3} className='mb-4'>
            <CustomRangeDatePicker
              startDate={startDate}
              endDate={endDate}
              onChange={(dates) => {
                const [start, end] = dates;
                const formattedStart = start ? moment(start).format('YYYY-MM-DD') : null;
                const formattedEnd = end ? moment(end).format('YYYY-MM-DD') : null;
                setStartDate(start);
                setEndDate(end);

                setDataset({
                  ...dataset,
                  filters: {
                    ...dataset.filters,
                    dataHoliday: [formattedStart, formattedEnd],
                  },
                });
                
              }}
              label={t("HOLIDAY.DATE_RANGE")}
              
            />
          </Col>



          <Col xs="auto">

            <ButtonSearch onClick={(e) => handleSearch(e)} />

          </Col>

          <Col xs="auto">

            <ButtonClean onClick={async (e) => { e.preventDefault(); handleClean(e); }} />

          </Col>

          {/* <Col xs="auto">

            <DropdownButtonExport onClick={(type: string) =>
              FileExportService.Export(
                { ...RequestInputOutputParamsModelDefault, datasets: [dataset] },
                "holiday",
                type
              )}
            />

          </Col> */}

        </Row>
      </Form>

      <SafeDatatable
        key={flagClear ? "reset" : JSON.stringify(dataset.filters)}
        config={UtilService.verifyIdiomDataTable()}
        records={data?.data ? data?.data : []}
        columns={columns}
        dynamic={true}
        total_record={data?.pagination?.total_records ? data?.pagination?.total_records : 0}
        onChange={tableChangeHandler}
        className='table table-hover user-table align-items-center'
      />

    </>
  );
};

export default HolidayList;